import * as $ from 'jquery';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/tab';
import {destroySliders, getAll, mountSliders} from './glide';

const settings = {
	modal: '.js-modal',
	modalLink: '.js-modal-link',
	modalContainer: '.js-modal-container',
	buttonSpinner: '.js-button-spinner',
	buttonText: '.js-button-text',
};

const openModal = (e) => {
	const url = e.currentTarget.href;
	const $currentElement = $(e.currentTarget);
	const $modal = $(settings.modal);

	e.preventDefault();

	$.ajax({
		url,
		type: 'get',
		beforeSend() {
			$currentElement.find(settings.buttonSpinner).css('display', 'inline-block');
			$currentElement.find(settings.buttonText).hide();

			$modal.off('shown.bs.modal');

			$modal.on('shown.bs.modal', function() {
				const sliders = getAll();
				mountSliders(sliders);

				// override the standard bootstrap tab loader and handle it manually
				$(this).find('.nav a').on('click', function (event) {
					event.preventDefault();
					$(this).tab('show');

					// Re-render glide after the tab data loads into the dom
					$(this).on('shown.bs.tab', function () {
						mountSliders(sliders);
					});
				});
			});
		},
		complete() {
			$currentElement.find(settings.buttonSpinner).hide();
			$currentElement.find(settings.buttonText).css('display', 'inline');
		},
		success(data) {
			$(settings.modalContainer).html(data);
			$modal.modal('show');
		},
	});
};

const init = () => {
	$('body').on('click', settings.modalLink, openModal);
};

init();
